import {gtmEcommerceOfferTypeMap} from "@pg-rp/common-types";

import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";
import {IGTMEcommerce} from "../../../../tracking/types/ecommerce/IGTMEcommerce";
import {IGTMEcommerceItem} from "../../../../tracking/types/ecommerce/IGTMEcommerceItem";
import {OfferType} from "../../../types/OfferType";
import {IOfferArchivedData} from "../../../utils/is_offer_archived";
import {getGTMEcommerceItemStatus} from "../common/get_gtm_ecommerce_item_status";
import {getGtmEcommerceOfferAvailability, IGtmEcommerceOfferAvailabilityParams} from "../common/get_gtm_ecommerce_offer_availability";
import {getGtmEcommerceOfferItemBaseProps, IGtmEcommerceOfferItemBaseProps} from "../common/get_gtm_ecommerce_offer_item_base_props";
import {getGTMEcommerceOfferRegion, IGetGTMEcommerceOfferRegion} from "../common/get_gtm_ecommerce_offer_region";
import {getGTMEcommerceSpainParams, IGetGTMEcommerceSpainParams} from "../common/get_gtm_ecommerce_spain_params";

export interface IHitGTMOfferSelectItemParams {
    offer: {
        type: OfferType;
        region: IGetGTMEcommerceOfferRegion;
        construction_date_range?: {
            upper?: string;
        };
    } & IGtmEcommerceOfferItemBaseProps &
        IGetGTMEcommerceSpainParams & {
            configuration: IOfferArchivedData["configuration"] & IGtmEcommerceOfferAvailabilityParams["configuration"];
        };
    listId: string;
    listName: string;
}

export const hitGTMOfferSelectItem = (params: IHitGTMOfferSelectItemParams) => {
    const item = {
        ...getGtmEcommerceOfferItemBaseProps(params.offer),
        item_category: "investment",
        price: 1,
        quantity: 1,
        ...getGtmEcommerceOfferAvailability(params.offer),
        item_status: getGTMEcommerceItemStatus(params.offer),
        item_type: gtmEcommerceOfferTypeMap[params.offer.type],
        item_comissioning_date: params.offer?.construction_date_range?.upper || "na",
        item_list_name: params.listName,
        item_list_id: params.listId,
        variant: "na",
        ...getGTMEcommerceOfferRegion(params.offer.region),
        ...getGTMEcommerceSpainParams(params.offer.region.country, params.offer)
    } as IGTMEcommerceItem;

    const ecommerce: IGTMEcommerce = {
        item_list_id: params.listId,
        item_list_name: params.listName,
        items: [item]
    };

    hitGoogleTagManager({
        event: "select_item",
        ecommerce
    });
};
import {gtmEcommerceOfferTypeMap} from "@pg-rp/common-types";

import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";
import {IGTMEcommerce} from "../../../../tracking/types/ecommerce/IGTMEcommerce";
import {IGTMEcommerceItem} from "../../../../tracking/types/ecommerce/IGTMEcommerceItem";
import {OfferType} from "../../../types/OfferType";
import {IOfferArchivedData} from "../../../utils/is_offer_archived";
import {getGTMEcommerceItemStatus} from "../common/get_gtm_ecommerce_item_status";
import {getGtmEcommerceOfferAvailability, IGtmEcommerceOfferAvailabilityParams} from "../common/get_gtm_ecommerce_offer_availability";
import {getGtmEcommerceOfferItemBaseProps, IGtmEcommerceOfferItemBaseProps} from "../common/get_gtm_ecommerce_offer_item_base_props";
import {getGTMEcommerceOfferRegion, IGetGTMEcommerceOfferRegion} from "../common/get_gtm_ecommerce_offer_region";
import {getGTMEcommerceSpainParams, IGetGTMEcommerceSpainParams} from "../common/get_gtm_ecommerce_spain_params";

export interface IHitGTMOfferSelectItemParams {
    offer: {
        type: OfferType;
        region: IGetGTMEcommerceOfferRegion;
        construction_date_range?: {
            upper?: string;
        };
    } & IGtmEcommerceOfferItemBaseProps &
        IGetGTMEcommerceSpainParams & {
            configuration: IOfferArchivedData["configuration"] & IGtmEcommerceOfferAvailabilityParams["configuration"];
        };
    listId: string;
    listName: string;
}

export const hitGTMOfferSelectItem = (params: IHitGTMOfferSelectItemParams) => {
    const item = {
        ...getGtmEcommerceOfferItemBaseProps(params.offer),
        item_category: "investment",
        price: 1,
        quantity: 1,
        ...getGtmEcommerceOfferAvailability(params.offer),
        item_status: getGTMEcommerceItemStatus(params.offer),
        item_type: gtmEcommerceOfferTypeMap[params.offer.type],
        item_comissioning_date: params.offer?.construction_date_range?.upper || "na",
        item_list_name: params.listName,
        item_list_id: params.listId,
        variant: "na",
        ...getGTMEcommerceOfferRegion(params.offer.region),
        ...getGTMEcommerceSpainParams(params.offer.region.country, params.offer)
    } as IGTMEcommerceItem;

    const ecommerce: IGTMEcommerce = {
        item_list_id: params.listId,
        item_list_name: params.listName,
        items: [item]
    };

    hitGoogleTagManager({
        event: "select_item",
        ecommerce
    });
};
